import React from 'react';
import { Col, Input, Select, Space } from 'antd';
import { Controller, useFormContext } from 'react-hook-form';
import { isNativeDisplayCampaign } from '../../../../utils/api/campaign';
import FormItem from '../../utils/FormItem';
import UrlSpaceFixButton from '../../UrlSpaceFixButton';
import { noSpaceRule, optionalHttpUrlRule } from '../../../../utils/validators';
import { CampaignTagType } from '../../../../__generated__/graphql';

const pixelOption = { label: 'Pixel', value: CampaignTagType.Pixel }
const impressionPixelOption = { label: 'Impression Pixel', value: CampaignTagType.ImpressionPixel }

const TrackingPixelField = ({span = 12, disabled = false}) => {
  const { watch, control } = useFormContext()
  const campaignType = watch('type')

  const options = isNativeDisplayCampaign(campaignType) ? [impressionPixelOption] : [pixelOption, impressionPixelOption]

  // Validate the (optional) tag URL: a valid http(s) URL with no space. Skipped when the field
  // is read-only so a non-owner isn't shown an error they can't act on.
  const rules = disabled
    ? {}
    : {
        validate: {
          noSpace: (tag: any) => noSpaceRule(tag?.tagUrl ?? ''),
          format: (tag: any) => optionalHttpUrlRule(tag?.tagUrl ?? ''),
        },
      }

  return (
    <Col span={span}>
      <FormItem label='Tracking' top>
        <Controller
          control={control}
          name="trackingTag"
          rules={rules}
          render={({ field: {value, onChange}, fieldState }) => (
            <>
              <Space.Compact className="max-w-xs w-full campaignRateCardField">
                <Select
                  placeholder='Select type'
                  className="rounded-r-none"
                  style={{ width: "50%" }}
                  size="large"
                  value={value?.tagType}
                  onChange={(tagType) => onChange({...value, tagType})}
                  options={options}
                  disabled={disabled}
                />

                <Input
                  value={value?.tagUrl}
                  onChange={(event) => onChange({ ...value, tagUrl:  event.target.value })}
                  className="py-[3px] rounded-l-none rounded-r-md border-gray-300"
                  style={{ width: "50%" }}
                  maxLength={1000}
                  status={fieldState.error ? 'error' : undefined}
                  disabled={disabled || !value?.tagType}
                />
              </Space.Compact>
              {fieldState.error && (
                <div className="text-red-500 text-sm mt-1">
                  {fieldState.error.message}
                  <UrlSpaceFixButton name="trackingTag.tagUrl" disabled={disabled} />
                </div>
              )}
            </>
          )}
        />
      </FormItem>
    </Col>
  );
};

export default TrackingPixelField
